import {useEffect, useState} from 'react';
import './style.scss';

function NoAttendanceModal({info, setOpenModalAdd, updateAttendanceInfo}) {
    const [currentInfo, setCurrentInfo] = useState({});


    function onHandleChange(e, name) {
        setCurrentInfo({...currentInfo, [name]: e.target.value})
    }

    function setAttendanceInfo() {
        updateAttendanceInfo(currentInfo);
        setOpenModalAdd(false);
    }

    useEffect(() => {
        if (info) {
            setCurrentInfo(info);
        }
    }, []);

    return (
        <>
            {currentInfo && (
                <section className='modal-info-container'>
                    <button
                        onClick={() => setOpenModalAdd(false)}
                        className='button-close'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20.98'
                            height='20.981'
                            viewBox='0 0 20.98 20.981'>
                            <g id='Icon-close' transform='translate(-308.562 -311.686)'>
                                <path
                                    id='Trazado_679'
                                    data-name='Trazado 679'
                                    d='M-4680.317,593.807l16.738,16.738'
                                    transform='translate(4991 -280)'
                                    stroke='#bcbcbc'
                                    strokeLinecap='round'
                                    strokeWidth='3'
                                />
                                <path
                                    id='Trazado_680'
                                    data-name='Trazado 680'
                                    d='M-4663.579,593.807l-16.738,16.738'
                                    transform='translate(4991 -280)'
                                    fill='none'
                                    stroke='#bcbcbc'
                                    strokeLinecap='round'
                                    strokeWidth='3'
                                />
                            </g>
                        </svg>
                    </button>
                    <div className='info-container'>
                        <h2 className='title'>{currentInfo.title}</h2>
                        <label htmlFor=''>
                            <p className='input-title argument'>
                                {currentInfo.argumentValue}
                                <span>*</span>
                            </p>
                            <input
                                type='text'
                                onChange={e => onHandleChange(e, 'argument')}
                                className='input-form'
                            />
                        </label>
                        <label htmlFor=''>
                            <p className='input-title observations'>
                                {' '}
                                {currentInfo.observations}
                            </p>
                            <input
                                type='text'
                                onChange={e => onHandleChange(e, 'notes')}
                                className='input-form'
                            />
                        </label>
                        <div className='buttons-container'>
                            <button
                                onClick={setAttendanceInfo}
                                className='blue-site-button'>
                                GUARDAR
                            </button>
                            <button
                                onClick={() => setOpenModalAdd(false)}
                                className='button-white-border-blue'>
                                CANCELAR
                            </button>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
}

export default NoAttendanceModal;
